// Formatea unha data no formato "luns 31 de agosto"
export const formatGalicianDate = (dateString: string): string => {
  const date = new Date(dateString)
  const weekday = new Intl.DateTimeFormat('gl-ES', { weekday: 'long' }).format(date)
  const dayMonth = new Intl.DateTimeFormat('gl-ES', { day: 'numeric', month: 'long' }).format(date)
  return `${weekday} ${dayMonth}`
}
